<template>
  <div class="footer">
    版权所有 Copyright © 2005 福建师大附中（Fjsdfz.com） 闽ICP备19018342号
  </div>
</template>

<script>
export default {}
</script>

<style>
.footer {
  background-color: #8c1a10;
  text-align: center;
  color: white;
  padding: 15px;
  font-size: 14px;
  line-height: 1;
}
</style>
